module.exports = __webpack_public_path__ + "static/logo-consulting-partner-aws-mangrove-6094d65333ae7832454d9260088dd3ea.svg";